<template>
  <v-row class="modern-profile-layout" no-gutters justify="center">
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <v-col cols="12" md="8" lg="6">
      <v-card elevation="0" class="modern-profile-card" rounded="xl">
        <v-card-title class="profile-header">
          <v-avatar size="64" class="profile-avatar">
            <v-icon large color="white">mdi-account</v-icon>
          </v-avatar>
          <div class="profile-info">
            <h2 class="profile-name">{{ $store.state.userData && $store.state.userData.userName }}</h2>
            <span class="profile-phone">{{ $store.state.userData && $store.state.userData.phone }}</span>
          </div>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="pa-6">
          <h3 class="section-title">تغيير كلمة المرور</h3>

          <v-form ref="form" v-model="valid">
            <v-text-field
              v-model="currentPassword"
              :append-icon="showCurrent ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showCurrent ? 'text' : 'password'"
              label="كلمة المرور الحالية"
              outlined
              :rules="[rules.required]"
              @click:append="showCurrent = !showCurrent"
            ></v-text-field>

            <v-text-field
              v-model="newPassword"
              :append-icon="showNew ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showNew ? 'text' : 'password'"
              label="كلمة المرور الجديدة"
              outlined
              :rules="[rules.required, rules.min]"
              @click:append="showNew = !showNew"
            ></v-text-field>

            <v-text-field
              v-model="confirmPassword"
              :append-icon="showConfirm ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showConfirm ? 'text' : 'password'"
              label="تأكيد كلمة المرور الجديدة"
              outlined
              :rules="[rules.required, rules.match]"
              @click:append="showConfirm = !showConfirm"
            ></v-text-field>

            <v-alert v-if="message" :type="messageType" dense outlined class="mt-2">
              {{ message }}
            </v-alert>

            <v-btn color="primary" large block class="mt-4" :disabled="!valid" @click="submit">
              حفظ كلمة المرور
            </v-btn>
          </v-form>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      overlay: false,
      valid: false,
      currentPassword: "",
      newPassword: "",
      confirmPassword: "",
      showCurrent: false,
      showNew: false,
      showConfirm: false,
      message: "",
      messageType: "success",
      rules: {
        required: (v) => !!v || "حقل مطلوب",
        min: (v) => (v && v.length >= 6) || "يجب أن تكون 6 أحرف على الأقل",
        match: (v) => v === this.newPassword || "كلمة المرور غير متطابقة",
      },
    };
  },
  methods: {
    submit() {
      let self = this;
      if (!self.$refs.form.validate()) return;

      self.overlay = true;
      self.message = "";

      self.$http
        .put(
          `${self.$store.state.apiUrl}/user/changePassword`,
          {
            currentPassword: self.currentPassword,
            newPassword: self.newPassword,
          },
          { headers: { Authorization: `Bearer ${self.$store.state.user}` } }
        )
        .then(() => {
          self.overlay = false;
          self.message = "تم تغيير كلمة المرور بنجاح. سيتم تسجيل الخروج.";
          self.messageType = "success";
          setTimeout(() => {
            localStorage.removeItem("centerLogin");
            location.reload();
          }, 1500);
        })
        .catch((e) => {
          self.overlay = false;
          self.message = (e.response && e.response.data && e.response.data.message) || "حدث خطأ";
          self.messageType = "error";
        });
    },
  },
};
</script>

<style scoped>
.modern-profile-layout {
  padding: 24px 0;
}

.modern-profile-card {
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.profile-header {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 24px;
  background: linear-gradient(135deg, #0096ab 0%, #00bcd4 100%);
  color: white;
  border-radius: 20px 20px 0 0;
}

.profile-avatar {
  background: rgba(255, 255, 255, 0.2) !important;
  border: 2px solid rgba(255, 255, 255, 0.4);
}

.profile-info {
  display: flex;
  flex-direction: column;
}

.profile-name {
  font-size: 22px;
  font-weight: 700;
  margin: 0;
  color: white;
}

.profile-phone {
  font-size: 14px;
  opacity: 0.9;
  margin-top: 4px;
}

.section-title {
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 20px;
}
</style>
